import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RoutePlanPage } from './route-plan/route-plan.page';

const routes: Routes = [
  {
    path: '',
    component: RoutePlanPage,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./route-plan/route-plan.module').then(
            (m) => m.RoutePlanPageModule
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FlightPlanRoutingModule {}
